export default __webpack_public_path__ + "static/media/86-min.4e17eec5.jpg";